import React, { useEffect, useRef } from 'react';

export function AutoInput({ value, placeholder, className, onChange }) {
  const mirrorRef = useRef(null);
  const inputRef = useRef(null);
  const display = value || placeholder || '';

  useEffect(() => {
    if (mirrorRef.current && inputRef.current) {
      inputRef.current.style.width = mirrorRef.current.offsetWidth + 2 + 'px';
    }
  }, [display, className]);

  return (
    <span className="auto-input-wrap">
      <span ref={mirrorRef} className={`auto-input-mirror ${className}`} aria-hidden="true">{display}</span>
      <input ref={inputRef} className={className} value={value} onChange={onChange} placeholder={placeholder}/>
    </span>
  );
}
